<template>
  <div>
    <v-row>
      <v-col class="pl-4">
        <v-chip
          outlined
          class="ma-1"
          color="primary"
          close
          @click:close="removeOldFile(file)"
          v-for="(file, i) in getDokumenti"
          :key="i"
        >
          <v-icon color="red" @click="readFile(file.file_id)"
            >mdi-file-pdf</v-icon
          >
          <span @click="readFile(file.file_id)"> Pogledajte rad </span>
        </v-chip>
      </v-col>
    </v-row>
    <v-row v-if="tempAttachments.length">
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? '2' : '6'"
        v-for="tempAttachment in tempAttachments"
        :key="tempAttachment._id"
      >
        <v-card
          elevation="0"
          max-width="200px"
          style="border: 1px solid #1976d2"
        >
          <v-card-title class="pa-0"
            ><v-spacer></v-spacer
            ><v-icon
              @click="removeFile(tempAttachment)"
              color="primary"
              v-show="tempAttachment.id"
              >mdi-close</v-icon
            ></v-card-title
          >
          <p
            class="mb-0"
            ref="attachmentTitle"
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <v-icon size="25" color="primary">mdi-file-document</v-icon>
            {{ tempAttachment.name }}
          </p>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <small
              v-if="checkProgress(tempAttachment)"
              class="upload-prgress"
              >{{ `${tempAttachment.progress} %` }}</small
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AttachmentList",
  computed: {
    ...mapGetters(["getDokumenti"]),
  },
  methods: {
    checkProgress(attachment) {
      return attachment.progress === null ? false : true;
    },
    removeFile(file) {
      this.$emit("removeFile", file);
    },
    removeOldFile(file) {
      if (
        this.isInEdit &&
        Object.prototype.hasOwnProperty.call(file, "file_id")
      ) {
        this.$store
          .dispatch("deleteDokumentById", { dokumentId: file.id })
          .then((res) => {
            console.log(res);
            this.$store.dispatch("removeOldFile", file);
          });
      }
    },
    readFile(id) {
      let routeData = this.$router.resolve({
        path: `/dokumentRada/pdf`,
        name: "Rad",
        query: { fileId: id },
      });
      window.open(routeData.location.path + routeData.href, "_blank");
      // this.$router.push(`/${str}/pdf?fileId=${id}`)
    },
  },
  props: {
    tempAttachments: {
      type: Array,
    },
    attachments: {
      type: Array,
    },
    isInEdit: {
      type: Boolean,
    },
    selectedRad: {
      type: Object,
    },
  },
};
</script>

<style scoped>
ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px;
}
li {
  border: 1px solid;
  margin-bottom: 8px;
  border-radius: 8px;
  margin-right: 8px;
  padding: 0 10px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
